import FBConfig from "../FBConfig";

const ReadFBLoginDevices = async ({ logout }) => {

    const user_uuid = localStorage.getItem("user_uuid")
    const outlet_uuid = localStorage.getItem("outlet_uuid")
    if (!outlet_uuid || !user_uuid) return alert("no outlet or user uuid found in local storage", { user_uuid, outlet_uuid });

    const collection_path = outlet_uuid + "/loggedIn-devices/"
    const ref = FBConfig.ref(FBConfig.db, collection_path);
    FBConfig.onChildChanged(ref, async data => {
        try {
            const deviceId = await data.val();
            if (data.key === user_uuid && deviceId !== sessionStorage?.getItem('deviceId')) logout()
        }
        catch (error) {
            console.error(error);
        }
    });
}

export const clearFBDeviceId = async callback => {
    if (!navigator.onLine && callback) return callback()
    const path = `${localStorage.getItem('outlet_uuid')}/loggedIn-devices/${localStorage.getItem('user_uuid')}`
    const ref = FBConfig.ref(FBConfig.db, path)
    const SNAPSHOT = await FBConfig.get(ref)
    const deviceId = await SNAPSHOT.val()
    console.log(deviceId, sessionStorage.getItem('deviceId'), deviceId === sessionStorage.getItem('deviceId'))
    if (deviceId === sessionStorage.getItem('deviceId')) await FBConfig.remove(ref)
    callback && callback()
}

export default ReadFBLoginDevices;